// Meta Pixel utility functions
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  // Only run in browser
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  // Check if already initialized
  if (window.fbq) return

  // Initialize fbq queue function
  window.fbq = function () {
    if (window.fbq.callMethod) {
      window.fbq.callMethod.apply(window.fbq, arguments)
    } else {
      window.fbq.queue.push(arguments)
    }
  }

  window._fbq = window.fbq
  window.fbq.push = window.fbq
  window.fbq.loaded = true
  window.fbq.version = '2.0'
  window.fbq.queue = []

  // Create script element safely
  try {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'

    // Append to document head safely
    if (document.head) {
      document.head.appendChild(script)
    } else if (document.body) {
      document.body.appendChild(script)
    }
  } catch (error) {
    console.error('Error loading Meta Pixel:', error)
  }

  // Initialize pixel and track PageView
  try {
    window.fbq('init', '901655005748604')
    window.fbq('track', 'PageView')
  } catch (error) {
    console.error('Error initializing Meta Pixel:', error)
  }
}

export const trackAddToCart = () => {
  if (window.fbq) {
    try {
      window.fbq('track', 'AddToCart')
    } catch (error) {
      console.error('Error tracking AddToCart:', error)
    }
  }
}
